module.exports = {"520624001":"思唐街道","520624002":"关中坝街道","520624003":"双塘街道","520624101":"塘头镇","520624102":"许家坝镇","520624103":"大坝场镇","520624104":"文家店镇","520624105":"鹦鹉溪镇","520624106":"合朋溪镇","520624107":"张家寨镇","520624108":"孙家坝镇","520624109":"青杠坡镇","520624110":"瓮溪镇","520624111":"凉水井镇","520624112":"邵家桥镇","520624113":"大河坝镇","520624114":"亭子坝镇","520624115":"香坝镇","520624116":"长坝镇","520624117":"板桥镇","520624201":"思林土家族苗族乡","520624203":"胡家湾苗族土家族乡","520624204":"宽坪苗族土家族乡","520624206":"枫芸土家族苗族乡","520624210":"三道水土家族苗族乡","520624211":"天桥土家族苗族乡","520624212":"兴隆土家族苗族乡","520624213":"杨家坳苗族土家族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520624.json
// module id = 2630
// module chunks = 0